module.exports = __webpack_public_path__ + "img/Icone-mes-infos.d5e01d2b.svg";